var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupo25(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43,
    height: 42,
    viewBox: "0 0 43 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_25",
    "data-name": "Grupo 25",
    transform: "translate(-0.149 -0.163)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_770",
    "data-name": "Ret\\xE2ngulo 770",
    width: 43,
    height: 42,
    rx: 8,
    transform: "translate(0.149 0.163)",
    fill: "#3542c2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "edit",
    d: "M0,14.877,11.549,3.328l3.915,3.915L3.915,18.792H0ZM18.5,4.209,16.59,6.117,12.675,2.2,14.584.294a1.063,1.063,0,0,1,1.468,0L18.5,2.741a1,1,0,0,1,.294.734,1,1,0,0,1-.294.734Z",
    transform: "translate(12.432 11.564)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupo25);
export default __webpack_public_path__ + "static/media/Grupo_25.621fad9ffb42ee82e309d5c1061cb124.svg";
export { ForwardRef as ReactComponent };